import { Quote } from '../../types/quote'
import styles from './QuoteCard.module.css'

interface QuoteCardProps {
  quote: Quote
  variant?: 'large' | 'small'
}

function QuoteCard({ quote, variant = 'small' }: QuoteCardProps) {
  return (
    <div
      className={
        variant === 'large'
          ? `${styles.card} ${styles.large}`
          : styles.card
      }
    >
      <blockquote className={styles.text}>
        {quote.text}
      </blockquote>
      {quote.author && (
        <cite className={styles.author}>— {quote.author}</cite>
      )}
    </div>
  )
}

export default QuoteCard
